
import Vue from 'vue';
import router from '../../router';
import User from '../../apis/User';
import Schedules from '../../apis/Schedules';
import audience from './audience';

const state = {
    schedule: null,
    schedules: [],
    scheduleToStore: [
        {
            domain_id: null,
            type: "spam-recurring",
            name: "",
            frequency: [],
            audiences: null,
            time: null,
            date_start: [
                {
                    date: null,
                    time: null,
                },
            ],
            date_end: [
                {
                    date: null,
                    time: null,
                },
            ],
            days_of_week: [],
            timezone: null,
        },
    ],
    scheduleError: null
};

const getters = {};

const actions = {
    getSchedules({ commit }, { domainId, limit, page, pageLength })
    {
        return new Promise((resolve, reject) =>
        {

            Schedules.getSchedules(domainId, limit, page, pageLength)
                .then((response) =>
                {
                    resolve(response);
                    commit("GET_SCHEDULES", response.data.data.data);
                })
                .catch((error) =>
                {
                    reject(error);
                    if (error.response) {
                        commit("DETECT_ERROR", error.response);
                    }
                });
        });
    },
    getSchedule()
    {

    },
    storeSchedule({ commit }, { schedule, shouldBeUpdated, id })
    {
        return new Promise((resolve, reject) =>
        {
            Schedules.createOrUpdate(schedule)
                .then((response) =>
                {
                    resolve(response);
                    return response.data.data;
                })
                .then((data) =>
                {
                    console.log(shouldBeUpdated, "shouldBeUpdated");
                    if (shouldBeUpdated) {
                        commit("UPDATE_SCHEDULE", { schedule, id });
                    } else {
                        commit("ADD_SCHEDULE", data);
                    }
                })
                .catch((error) =>
                {
                    reject(error);
                    if (error.response) {
                        commit("DETECT_ERROR", error.response);
                    }
                });

        });
    },
    addDripIntoSchedule({ commit }, { drip, scheduleId })
    {
        commit("ADD_DRIP_INTO_SCHEDULE", { drip, scheduleId });
    },
    removeDripFromSchedule({ commit }, { drip, scheduleId })
    {
        commit("REMOVE_DRIP_FROM_SCHEDULE", { drip, scheduleId });
    },
    unbindAudienceFromSchedule({ commit }, { audienceId, scheduleId })
    {
        commit("UNBIND_AUDIENCE_FROM_SCHEDULE", { audienceId, scheduleId });
    },
    editSchedule() { },
    removeSchedule({ commit }, id)
    {
        return new Promise((resolve, reject) =>
        {
            Schedules.delete(id)
                .then((response) =>
                {
                    resolve(response);
                    commit("REMOVE_SCHEDULE", id);
                })
                .catch((error) =>
                {
                    reject(error);
                    if (error.response) {
                        commit("DETECT_ERROR", error.response);
                    }
                });
        });
    },
    resetSchedules({ commit })
    {
        commit("RESET_SCHEDULES");
    },
    resetScheduleToStore({ commit })
    {
        commit("RESET_SCHEDULE_TO_STORE");
    }
};

const mutations = {
    GET_SCHEDULES(state, schedules)
    {
        state.schedules = schedules;
    },
    GET_SCHEDULE() { },
    REMOVE_SCHEDULE(state, id)
    {
        const index = state.schedules.findIndex(schedule => schedule.id === id);

        if (index !== -1) {
            state.schedules.splice(index, 1);
        }
    },
    ADD_SCHEDULE(state, schedule)
    {
        console.log(state.schedules.length)

        state.schedules.unshift(schedule[0]);

    },
    UPDATE_SCHEDULE(state, { schedule, id })
    {
        const index = state.schedules.findIndex(schedule => schedule.id == id);

        if (index !== -1) {
            state.schedules[index].name = schedule[0].name;
            state.schedules[index].frequency = schedule[0].frequency;
            state.schedules[index].time = schedule[0].time;
            state.schedules[index].date_start = schedule[0].date_start;
            state.schedules[index].date_end = schedule[0].date_end;
            state.schedules[index].days_of_week = schedule[0].days_of_week;
            state.schedules[index].timezone = schedule[0].timezone;
            state.schedules[index].audiences = schedule[0].audiences;
            state.schedules[index].drips = schedule[0].drips;
        }
    },
    ADD_DRIP_INTO_SCHEDULE(state, { drip, scheduleId })
    {
        const index = state.schedules.findIndex(schedule => schedule.id == scheduleId);

        if (index !== -1) {
            state.schedules[index].drips.push(drip);
        }
    },
    REMOVE_DRIP_FROM_SCHEDULE(state, { drip, scheduleId })
    {
        const scheduleIndex = state.schedules.findIndex(schedule => schedule.id == scheduleId);
        const dripIndex = state.schedules[scheduleIndex].drips.findIndex(el => el.id === drip.id);

        if (dripIndex !== -1 && scheduleId !== -1) {
            state.schedules[scheduleIndex].drips.splice(dripIndex, 1);
        }
    },
    UNBIND_AUDIENCE_FROM_SCHEDULE(state, { audienceId, scheduleId })
    {
        const scheduleIndex = state.schedules.findIndex(schedule => schedule.id == scheduleId);
        const audienceIndex = state.schedules[scheduleIndex].audiences.findIndex(el => el.id === audienceId);

        if (audienceIndex !== -1 && scheduleId !== -1) {
            state.schedules[scheduleIndex].audiences.splice(audienceIndex, 1);
        }
    },
    DETECT_ERROR(state, error)
    {
        if (error.status == 401 || error.status == 419) {
            User.logout().then(() =>
            {
                localStorage.removeItem("auth");
                router.push({ name: "Login", path: router.currentRoute.path });
            });
        } else if (error.data.message !== undefined && router.currentRoute.name !== "NewWebsite") {
            state.scheduleError = error.data.message;
        }
        setTimeout(() =>
        {
            state.scheduleError = "";
        }, 1000);
    },
    RESET_SCHEDULES(state)
    {
        state.schedules = [];
    },
    RESET_SCHEDULE_TO_STORE(state)
    {
        state.scheduleToStore = [{
            domain_id: null,
            type: "spam-recurring",
            name: "",
            frequency: [],
            audiences: null,
            time: null,
            date_start: [
                {
                    date: null,
                    time: null,
                },
            ],
            date_end: [
                {
                    date: null,
                    time: null,
                },
            ],
            days_of_week: [],
            timezone: null,
        }];
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};